import { create } from 'zustand'

interface VisibilityStore {
    // HOME
    isHomeContentVisible: boolean
    setHomeContentVisible: (isPipMode?: boolean) => void

    // EPG
    isEpgContentVisible: boolean
    setEpgContentVisible: (isPipMode?: boolean) => void

    // TV
    isTvContentVisible: boolean
    setTvContentVisible: (isVisible?: boolean) => void

    // VOD
    isVodContentVisible: boolean
    setVodContentVisible: (isPipMode?: boolean) => void

    // SERIES
    isSeriesContentVisible: boolean
    setSeriesContentVisible: (isPipMode?: boolean) => void

    // LOGIN
    setLoginContentVisible: () => void

    // SETTINGS
    isSettingsContentVisible: boolean
    setSettingsContentVisible: () => void
}

export const useVisibilityStore = create<VisibilityStore>((set) => ({
    // LOGIN
    setLoginContentVisible: () =>
        set(() => ({
            isHomeContentVisible: false,
            isTvContentVisible: false,
            isVodContentVisible: false,
            isEpgContentVisible: false,
            isSettingsContentVisible: false,
            isSeriesContentVisible: false,
        })),

    // HOME
    isHomeContentVisible: false,
    setHomeContentVisible: (isPipMode = false) =>
        set(() => ({
            isLoginContentVisible: false,
            isHomeContentVisible: true,
            isTvContentVisible: isPipMode,
            isVodContentVisible: false,
            isSeriesContentVisible: false,
            isEpgContentVisible: false,
            isSettingsContentVisible: false,
        })),

    // TV
    isTvContentVisible: false,
    setTvContentVisible: (isVisible?: boolean) =>
        set(() => ({
            isLoginContentVisible: false,
            isHomeContentVisible: false,
            isTvContentVisible: isVisible,
            isVodContentVisible: false,
            isSeriesContentVisible: false,
            isEpgContentVisible: false,
            isSettingsContentVisible: false,
        })),

    // EPG
    isEpgContentVisible: false,
    setEpgContentVisible: (isPipMode = false) =>
        set(() => ({
            isLoginContentVisible: false,
            isHomeContentVisible: false,
            isTvContentVisible: isPipMode,
            isVodContentVisible: false,
            isSeriesContentVisible: false,
            isEpgContentVisible: true,
            isSettingsContentVisible: false,
        })),

    // VOD
    isVodContentVisible: false,
    setVodContentVisible: () =>
        set(() => ({
            isLoginContentVisible: false,
            isHomeContentVisible: false,
            isTvContentVisible: false,
            isVodContentVisible: true,
            isSeriesContentVisible: false,
            isEpgContentVisible: false,
            isSettingsContentVisible: false,
        })),

    // SERIES
    isSeriesContentVisible: false,
    setSeriesContentVisible: () =>
        set(() => ({
            isLoginContentVisible: false,
            isHomeContentVisible: false,
            isTvContentVisible: false,
            isVodContentVisible: false,
            isSeriesContentVisible: true,
            isEpgContentVisible: false,
            isSettingsContentVisible: false,
        })),

    // SETTINGS
    isSettingsContentVisible: false,
    setSettingsContentVisible: () =>
        set(() => ({
            isLoginContentVisible: false,
            isHomeContentVisible: false,
            isTvContentVisible: false,
            isVodContentVisible: false,
            isSeriesContentVisible: false,
            isEpgContentVisible: false,
            isSettingsContentVisible: true,
        })),
}))
